module.exports = __webpack_public_path__ + "img/standard.c20eb327.png";